var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGreenArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m24.686.69-1.41 1.41 5.58 5.59H.314v2h28.542l-5.58 5.59 1.41 1.41 8-8-8-8Z",
  fill: "#006A5C"
})));
export { SvgGreenArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAzMyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjY4NiAwLjY4OTQ1M0wyMy4yNzYgMi4wOTk0NUwyOC44NTYgNy42ODk0NUgwLjMxMzk2NVY5LjY4OTQ1SDI4Ljg1NkwyMy4yNzYgMTUuMjc5NUwyNC42ODYgMTYuNjg5NUwzMi42ODYgOC42ODk0NUwyNC42ODYgMC42ODk0NTNaIiBmaWxsPSIjMDA2QTVDIi8+Cjwvc3ZnPgo=";